import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function ContractView() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">이실장에서는 복잡하고 다양한 공부가 <strong>1분만에 자동으로 열람!</strong></p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ul className="list_dot"><li><h4 className="title">계약서를 작성하실 주소를 입력하고</h4><Image className="img_guide" src="/image/mobile/popup/contract01_01.png" alt={"\uACC4\uC57D\uC11C\uB97C \uC791\uC131\uD558\uC2E4 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uAE30"} width={100} height={100} /></li><li><h4 className="title">열람을 원하는 공부만 선택하면</h4><Image className="img_guide" src="/image/mobile/popup/contract01_02.png" alt={"\uC5F4\uB78C\uC744 \uC6D0\uD558\uB294 \uACF5\uBD80\uB9CC \uC120\uD0DD\uD558\uAE30"} width={100} height={100} /></li><li><h4 className="title">선택한 공부를 이실장이 알아서 열람해 드려요.</h4><Image className="img_guide" src="/image/mobile/popup/contract01_03.png" alt={"\uC120\uD0DD\uD55C \uACF5\uBD80\uB97C \uC774\uC2E4\uC7A5\uC774 \uC54C\uC544\uC11C \uC5F4\uB78C"} width={100} height={100} /></li></ul></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}